import React from "react";
import { RouterView } from "./router";
import { useEffect } from "react";

export function App() {
  useEffect(() => {
    // const jssStyles = document.querySelector("#jss-server-side");
    // if (jssStyles) {
    //   jssStyles.parentElement.removeChild(jssStyles);
    // }
  }, []);

  console.log("render app");

  return (
    <div>
      <RouterView></RouterView>
    </div>
  );
}
